<template>
    <div class="cash-in-and-out" :class="$t('Dividend.box-name')">
        <page-navigate></page-navigate>
        <section class="flex items-start funding_header">
            <div class="funding_main">
                <h1 class="funding_title super_large-80_bold md-title-32_bold word1">
                    存款取款
                </h1>
                <h2 class="funding_desc subtitle-20_regular md-body-14_regular word3">
                    多币种支持，覆盖全球支付渠道，资金进出更轻松
                </h2>
                <a :href="signupUrl" target="_blank">
                    <div class="funding_btn primary-default_large cursor-pointer">
                        <span class="word4">立即开户</span>
                        <span class="iconfont icon-right"></span>
                    </div>
                </a>
            </div>
            <img src="@/assets/image/funding/fundingContainer1Model.png" alt="" class="funding_model" />
        </section>
        <section class="funding-advantage">
            <h2 class="mobile md-title-24_bold word5">产品优势</h2>
            <div class="flex justify-center items-center contentBox funding-advantage_cardList">
                <div class="funding-advantage_card">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                        <path d="M35.7704 35.077V26.318M8.3418 8.79993H21.3704M8.3418 15.1064H14.8561" stroke="#A52933"
                            stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M21.4293 39.6319C21.1673 38.5076 21.0286 37.3345 21.0286 36.1282C21.0286 27.8078 27.6292 21.0627 35.7714 21.0627C43.9137 21.0627 50.5143 27.8078 50.5143 36.1282C50.5143 44.4487 43.9137 51.1938 35.7714 51.1938H15.5429M31.6571 45.588H8M35.7714 56.7996H23.0857M21.4293 21.0627L18.9714 19.3109M50.5143 21.0627L52.9143 18.6102M31.6571 15.8073V8.80005H40.2286V15.8073M29.2571 8.80005H42.9714"
                            stroke="#9F734C" stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M35.7715 56.7999C46.9435 56.7999 56.0001 47.5451 56.0001 36.1286C56.0001 24.7121 46.9435 15.4573 35.7715 15.4573C24.5996 15.4573 15.543 24.7121 15.543 36.1286C15.543 37.5692 15.6872 38.9754 15.9617 40.3329"
                            stroke="#9F734C" stroke-width="1.6" stroke-linecap="round" />
                        <ellipse cx="35.8913" cy="37.3023" rx="1.94595" ry="1.98854" stroke="#A52933" stroke-width="1.6"
                            stroke-linecap="round" />
                    </svg>
                    <div class="funding-advantage_cardTip subtitle-18_medium md-body-16_medium word6">
                        极速到账
                    </div>
                    <div class="funding-advantage_cardDesc body-14_regular md-footnote-regular_12 word7">
                        入金最快 1 分钟到账
                    </div>
                </div>
                <div class="pc funding-advantage_cardSplitLine"></div>
                <div class="funding-advantage_card">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                        <path d="M31.847 50.3871V55.4666M18.5801 55.4666H45.7611" stroke="#9F734C" stroke-width="1.6"
                            stroke-linecap="round" />
                        <path
                            d="M17.7811 16.127C15.4417 19.1107 14.0508 22.8473 14.0508 26.9026C14.0508 36.6721 22.123 44.5918 32.0807 44.5918C42.0383 44.5918 50.1105 36.6721 50.1105 26.9026C50.1105 22.8473 48.7196 19.1107 46.3802 16.127"
                            stroke="#9F734C" stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M18.1343 8.79919C12.4668 12.9758 8.80078 19.6255 8.80078 27.1153C8.80078 39.7587 19.2477 50.0082 32.1347 50.0082C45.0217 50.0082 55.4686 39.7587 55.4686 27.1153C55.4686 19.6255 51.8026 12.9758 46.135 8.79919"
                            stroke="#9F734C" stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M43.7591 26.1913C43.7591 26.2245 43.7591 26.2592 43.7575 26.2926C37.8583 27.0209 33.1832 31.6077 32.4409 37.3954C32.4071 37.3969 32.3733 37.3969 32.3395 37.3969C32.3038 37.3969 32.2684 37.3969 32.2346 37.3954C31.4923 31.6074 26.8172 27.0209 20.9196 26.2926C20.918 26.2594 20.918 26.2247 20.918 26.1913C20.918 26.1581 20.918 26.1232 20.9196 26.09C26.8172 25.3619 31.4923 20.7769 32.2346 14.989C32.2684 14.9874 32.3038 14.9874 32.3392 14.9874C32.373 14.9874 32.4068 14.9874 32.4406 14.989C33.183 20.7767 37.8581 25.3619 43.7573 26.09C43.7589 26.1232 43.7591 26.1581 43.7591 26.1913Z"
                            stroke="#A52933" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <div class="funding-advantage_cardTip subtitle-18_medium md-body-16_medium word8">
                        0 手续费
                    </div>
                    <div class="funding-advantage_cardDesc body-14_regular md-footnote-regular_12 word9">
                        存款取款均不收取任何手续费
                    </div>
                </div>
                <div class="pc funding-advantage_cardSplitLine"></div>
                <div class="funding-advantage_card">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                        <path
                            d="M28.1919 44.9161C26.3263 45.7829 24.2507 46.2662 22.0635 46.2662C13.9405 46.2662 7.35547 39.5996 7.35547 31.3759C7.35547 23.1522 13.9405 16.4856 22.0635 16.4856C25.1313 16.4856 27.9797 17.4364 30.3368 19.0629"
                            stroke="#9F734C" stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M26.7428 37.5834C25.5781 38.3675 24.1799 38.8243 22.6763 38.8243C18.6148 38.8243 15.3223 35.491 15.3223 31.3791C15.3223 27.2673 18.6148 23.934 22.6763 23.934C24.4154 23.934 26.0136 24.5451 27.2726 25.5669"
                            stroke="#A52933" stroke-width="1.6" stroke-linecap="round" />
                        <path d="M20.2275 29.8287H13.4863M20.2275 32.9309H13.4863" stroke="#A52933" stroke-width="1.6"
                            stroke-linecap="round" />
                        <path d="M18.0801 13.3863C22.6763 8.93983 34.6879 2.71485 45.9641 13.3863" stroke="#9F734C"
                            stroke-width="1.6" stroke-linecap="round" />
                        <path d="M45.9648 50.6134C41.3686 55.0598 29.357 61.2848 18.0808 50.6134" stroke="#9F734C"
                            stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M48.7064 45.5666C46.5329 46.8052 44.0242 47.5117 41.3524 47.5117C33.0601 47.5117 26.3379 40.7062 26.3379 32.3111C26.3379 23.9161 33.0601 17.1106 41.3524 17.1106C49.6446 17.1106 56.3669 23.9161 56.3669 32.3111C56.3669 34.156 56.0422 35.9241 55.4476 37.5602M52.077 42.9493C52.8322 42.169 53.5051 41.3067 54.0812 40.3767"
                            stroke="#9F734C" stroke-width="1.6" stroke-linecap="round" />
                        <path
                            d="M46.8689 27.0353H39.8555C38.3136 27.0353 37.0636 28.2853 37.0636 29.8272C37.0636 31.3692 38.3136 32.6191 39.8555 32.6191H43.0026C44.6302 32.6191 45.9497 33.9386 45.9497 35.5662C45.9497 37.1938 44.6302 38.5132 43.0026 38.5132H35.8379M41.3534 22.6923V41.9256"
                            stroke="#A52933" stroke-width="1.6" stroke-linecap="round" />
                    </svg>
                    <div class="funding-advantage_cardTip subtitle-18_medium md-body-16_medium word10">
                        全球覆盖
                    </div>
                    <div class="funding-advantage_cardDesc body-14_regular md-footnote-regular_12 word11">
                        支持多币种与本地支付渠道
                    </div>
                </div>
            </div>
        </section>
        <section class="funding-solution">
            <h2
                class="funding-solution_title title-48_bold md-title-24_bold text-center contentBox word12 scroll-fade-up">
                全球多币种资金解决方案
            </h2>
            <h3
                class="funding-solution_desc subtitle-20_regular md-footnote-regular_12 text-center contentBox word13 scroll-fade-up">
                提供全球主要货币的即时入金与出金服务，简化国际和跨货币交易流程，实现全天候、便捷的资金流动
            </h3>
            <div class="funding-solution_logoList flex justify-center items-center flex-wrap scroll-fade-up">
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddTopLeft" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddTopRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomLeft" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo1.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddTopRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo2.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomLeft mobile" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddTopRight pc" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo3.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddTopRight pc" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo4.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomLeft" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo5.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo6.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomLeft mobile" />
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo7.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoItem">
                    <img src="@/assets/image/funding/fundingResolutionLogoCorner.svg"
                        class="funding-solution_logoItemCorner solution_logoItemAddBottomRight" />
                    <img src="@/assets/image/funding/fundingResolutionLogo8.png" class="grayscale" alt="" />
                </div>
                <div class="funding-solution_logoListRowLine"></div>
                <div class="funding-solution_logoListRowLine"></div>
                <div class="funding-solution_logoListRowLine"></div>
                <div class="funding-solution_logoListColumnLine"></div>
                <div class="funding-solution_logoListColumnLine"></div>
                <div class="funding-solution_logoListColumnLine"></div>
                <div class="funding-solution_logoListColumnLine"></div>
                <div class="funding-solution_logoListColumnLine"></div>
                <div class="funding-solution_logoListRowLine"></div>
                <div class="funding-solution_logoListRowLine"></div>
            </div>
        </section>
        <section class="funding-protect">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold text-center word15 scroll-fade-up">
                    资金安全，全面保障
                </h2>
                <h3
                    class="funding-protect_desc subtitle-20_regular md-footnote-regular_12 text-center word16 scroll-fade-up">
                    跨国银行独立托管账户，顶级专业保险，为您的<br class="mobile" />资金提供多重保护
                </h3>
                <div class="flex justify-center flex-wrap funding-protect_cardList">
                    <div class="funding-protect_card scroll-fade-left">
                        <div class="funding-protect_cardTitle subtitle-20_medium md-subtitle-18_medium word17">
                            资金隔离托管
                        </div>
                        <div class="funding-protect_cardDesc content-16_regular md-content-14_regular word18">
                            EBC拥有巴克莱银行企业账户，该账户要求企业营业额和存款达到650万英镑以上且须要通过巴克莱一系列严格的财务审计和背景调查。EBC英国严格执行CASS规定，通过特定信托函独立托管投资者资金，保障资金安全与独立。
                        </div>
                        <a href="/security" class="funding-protect_cardBtn">
                            <div class="secondary-default_medium">
                                <span class="word19">了解更多</span>
                                <span class="iconfont icon-right"></span>
                            </div>
                        </a>
                        <div class="funding-protect_cardLogoList flex justify-center items-center">
                            <img src="@/assets/image/funding/fundingProtectLogo1.png" alt=""
                                class="funding-protect_cardLogo1" />
                        </div>
                    </div>
                    <div class="funding-protect_card scroll-fade-right">
                        <div class="funding-protect_cardTitle subtitle-20_medium md-subtitle-18_medium word20">
                            专业金融责任险
                        </div>
                        <div class="funding-protect_cardDesc content-16_regular md-content-14_regular word21">
                            EBC每年向英国劳合社和澳洲昆士兰购买四大专业保险，总保额超3000万美金，提供多重安全保障
                        </div>
                        <a href="/security" class="funding-protect_cardBtn">
                            <div class="secondary-default_medium">
                                <span class="word19">了解更多</span><span class="iconfont icon-right"></span>
                            </div>
                        </a>
                        <div class="funding-protect_cardLogoList flex justify-center items-center">
                            <img src="@/assets/image/funding/fundingProtectLogo2.png" alt=""
                                class="funding-protect_cardLogo2" />
                            <img src="@/assets/image/funding/fundingProtectLogo3.png" alt=""
                                class="funding-protect_cardLogo3" />
                            <img src="@/assets/image/funding/fundingProtectLogo4.png" alt=""
                                class="funding-protect_cardLogo4" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="funding-way">
            <div class="contentBox">
                <h2 class="title-48_bold md-title-24_bold text-center word28 scroll-fade-up">
                    出入金方式
                </h2>
                <h3
                    class="funding-way_desc subtitle-20_regular md-footnote-regular_12 text-center word29 scroll-fade-up">
                    支持本地银行转账，国际电汇，电子钱包等多种出入金方式
                </h3>
                <div class="funding-way_container flex flex-col items-center ">
                    <div class="tableOverflowScrollContainer scroll-fade-up" style="position: relative">
                        <div class="corner-mask mobile"></div>
                        <div class="fake-scrollbar mobile">
                            <div class="fake-thumb"></div>
                        </div>
                        <div class="scrollTable">
                            <div class="funding-way_table contentBox">
                                <table>
                                    <thead>
                                        <tr class="thead body-16_medium md-body-14_medium">
                                            <th>出入金方式</th>
                                            <th>支持货币</th>
                                            <th>入金单笔限额 (USD)</th>
                                            <th>入金到账时间</th>
                                            <th>出金处理时间</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="body-14_regular">
                                            <td>
                                                <div class="innerTd">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M12.0002 1.97998L21.897 6.05176L21.897 8.45998H2.10352L2.10352 6.05176L12.0002 1.97998Z"
                                                            stroke="#A52933" stroke-width="1.5"
                                                            stroke-linejoin="round" />
                                                        <path d="M4.91992 11.28V19.32" stroke="#9F734C"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                        <path d="M12 11.28V19.32" stroke="#9F734C" stroke-width="1.5"
                                                            stroke-linecap="round" />
                                                        <path d="M18.9609 11.28V19.32" stroke="#9F734C"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                        <path d="M2.40039 21.8401L21.6 21.9582" stroke="#9F734C"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                    本地银行
                                                </div>
                                            </td>
                                            <td>CNY</td>
                                            <td>110-20,000</td>
                                            <td>15分钟-1小时</td>
                                            <td rowspan="4">1个工作日</td>
                                        </tr>
                                        <tr class="body-14_regular">
                                            <td>
                                                <div class="innerTd">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <mask id="path-1-inside-1_1161_8529" fill="white">
                                                            <rect x="2.87891" y="3" width="18.24" height="15.12"
                                                                rx="1" />
                                                        </mask>
                                                        <rect x="2.87891" y="3" width="18.24" height="15.12" rx="1"
                                                            stroke="#9F734C" stroke-width="3" stroke-linecap="round"
                                                            mask="url(#path-1-inside-1_1161_8529)" />
                                                        <path d="M13.8594 7.37988H17.4594" stroke="#A52933"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                        <path d="M5.28125 20.8799L18.6012 20.8799" stroke="#9F734C"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                        <path d="M13.8008 10.5601H15.9608" stroke="#A52933"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                        <path
                                                            d="M8.16667 14V13.2992C7.53268 13.2325 7.01634 13.0262 6.61765 12.6803C6.21895 12.3345 6.01307 11.8703 6 11.2878H7.32353C7.3366 11.5305 7.41503 11.7429 7.55882 11.9249C7.70915 12.1069 7.91176 12.2313 8.16667 12.2981V10.3777C8.10784 10.3595 8.04575 10.3413 7.98039 10.3231C7.92157 10.3049 7.85948 10.2867 7.79412 10.2685C7.26471 10.0986 6.85948 9.88017 6.57843 9.6132C6.30392 9.34623 6.16667 8.99128 6.16667 8.54835C6.16013 8.02655 6.34314 7.60789 6.71569 7.29238C7.08824 6.9708 7.5719 6.78574 8.16667 6.7372V6H8.82353V6.7463C9.41176 6.80091 9.88562 6.99204 10.2451 7.31968C10.6111 7.64126 10.8039 8.05688 10.8235 8.56655H9.48039C9.47386 8.3906 9.41176 8.22981 9.29412 8.08419C9.18301 7.9325 9.02614 7.82632 8.82353 7.76564V9.45848C8.87582 9.47668 8.9281 9.49488 8.98039 9.51308C9.03268 9.52522 9.08497 9.54039 9.13725 9.55859C9.47712 9.6678 9.78758 9.79522 10.0686 9.94084C10.3497 10.0865 10.5752 10.2806 10.7451 10.5233C10.915 10.76 11 11.0664 11 11.4425C11 11.7581 10.915 12.0523 10.7451 12.3254C10.5817 12.5984 10.3366 12.8259 10.0098 13.008C9.68954 13.1839 9.29412 13.284 8.82353 13.3083V14H8.16667ZM7.48039 8.46644C7.48039 8.6606 7.54248 8.81835 7.66667 8.9397C7.79085 9.05499 7.95752 9.1551 8.16667 9.24005V7.72924C7.96405 7.76564 7.79739 7.84755 7.66667 7.97497C7.54248 8.10239 7.48039 8.26621 7.48039 8.46644ZM9.66667 11.5245C9.66667 11.2818 9.58824 11.0906 9.43137 10.9511C9.27451 10.8115 9.0719 10.6932 8.82353 10.5961V12.3254C9.08497 12.289 9.29085 12.201 9.44118 12.0614C9.5915 11.9219 9.66667 11.7429 9.66667 11.5245Z"
                                                            fill="#A52933" />
                                                    </svg>
                                                    国际电汇
                                                </div>
                                            </td>
                                            <td>USD/EUR/GBP</td>
                                            <td>1,000-200,000</td>
                                            <td>2-5个工作日</td>
                                            <td class="mobile">1个工作日</td>
                                        </tr>
                                        <tr class="body-14_regular">
                                            <td>
                                                <div class="innerTd">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M15.46 8.56363L15.6458 7.86383C15.7876 7.33005 15.4698 6.78242 14.936 6.64067L7.81115 4.74863C7.27737 4.60688 6.72974 4.92469 6.58799 5.45847L5.95966 7.82457L5.76034 8.56363"
                                                            stroke="#A52933" stroke-width="1.5"
                                                            stroke-linecap="round" />
                                                        <path
                                                            d="M18.3428 8.78056L18.8042 6.95156L19.1225 5.68243C19.2568 5.14674 18.9314 4.60356 18.3957 4.46922L11.2454 2.6761C10.7097 2.54176 10.1665 2.86713 10.0321 3.40283L9.71388 4.67196"
                                                            stroke="#A52933" stroke-width="1.5"
                                                            stroke-linecap="round" />
                                                        <mask id="path-3-inside-1_1161_8537" fill="white">
                                                            <rect x="2.64062" y="8.04004" width="18.72" height="13.44"
                                                                rx="1" />
                                                        </mask>
                                                        <rect x="2.64062" y="8.04004" width="18.72" height="13.44"
                                                            rx="1" stroke="#9F734C" stroke-width="3"
                                                            stroke-linecap="round"
                                                            mask="url(#path-3-inside-1_1161_8537)" />
                                                        <path
                                                            d="M17.8789 12.99H20.6094V16.53H17.8789C16.9016 16.5298 16.1094 15.7369 16.1094 14.7595C16.1096 13.7823 16.9017 12.9902 17.8789 12.99Z"
                                                            stroke="#9F734C" stroke-width="1.5"
                                                            stroke-linecap="round" />
                                                    </svg>
                                                    电子钱包
                                                </div>
                                            </td>
                                            <td>USD</td>
                                            <td>50-10,000</td>
                                            <td>立即到账</td>
                                            <td class="mobile">1个工作日</td>
                                        </tr>
                                        <!-- <tr class="body-14_regular">
                                            <td>
                                                <div class="innerTd">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <circle cx="11.9991" cy="12" r="9.21" stroke="#9F734C"
                                                            stroke-width="1.5" stroke-linecap="round" />
                                                        <path
                                                            d="M13 5.25C13.4142 5.25 13.75 5.58579 13.75 6V6.85449C15.09 7.08709 16.1092 8.25368 16.1094 9.66016C16.1093 10.3673 15.8493 11.0125 15.4229 11.5107C16.2692 12.0619 16.8299 13.0146 16.8301 14.0996C16.8301 15.8026 15.4516 17.1827 13.75 17.1885V18C13.75 18.4142 13.4142 18.75 13 18.75C12.5858 18.75 12.25 18.4142 12.25 18V17.1895H11.75V18C11.75 18.4142 11.4142 18.75 11 18.75C10.5858 18.75 10.25 18.4142 10.25 18V17.1904H7.74023C7.32618 17.1904 6.9905 16.8544 6.99023 16.4404C6.99023 16.0262 7.32602 15.6904 7.74023 15.6904H8.84961V8.31055H7.74023C7.32618 8.31055 6.9905 7.97454 6.99023 7.56055C6.99023 7.14633 7.32602 6.81055 7.74023 6.81055H10.25V6C10.25 5.58579 10.5858 5.25 11 5.25C11.4142 5.25 11.75 5.58579 11.75 6V6.81055H12.25V6C12.25 5.58579 12.5858 5.25 13 5.25ZM13.2598 12.5107H10.3496V15.6895H13.7393C14.6174 15.6895 15.3301 14.9777 15.3301 14.0996C15.3299 13.2217 14.6173 12.5098 13.7393 12.5098H13.2783C13.2721 12.5098 13.266 12.5107 13.2598 12.5107ZM10.3496 11.0098H13.2773C14.0146 11.0003 14.6091 10.3996 14.6094 9.66016C14.6092 8.9148 14.0051 8.31063 13.2598 8.31055H10.3496V11.0098Z"
                                                            fill="#A52933" />
                                                    </svg>
                                                    数字货币
                                                </div>
                                            </td>
                                            <td>USDT-TRC20/ERC20</td>
                                            <td>50-50000</td>
                                            <td>1-15分钟</td>
                                            <td class="mobile">1个工作日</td>
                                        </tr> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="funding-way_tableFooter content-14_regular scroll-fade-up">
                        <span class="word44">入金到账说明：处理时间约为1至15分钟，超时未到账请及时联系客服或将您的订单编号与付款截图邮件至cs@ebc.com查询。</span><br />
                        <span class="word45">出金处理说明：当天
                            21:00（GMT+8）前提交的出金申请最快当天到账，之后提交的延迟至第第二天到账；因银行结算、支付渠道波动、节假日顺延等因素可能出现延迟，实际到账时间以收款账户记录为准。</span>
                    </div>
                    <a :href="signupUrl" class="funding-way_btn scroll-fade-up">
                        <div class="primary-default_large word30">即刻入金</div>
                    </a>
                </div>
            </div>
        </section>
        <section class="container4 commonQuestion">
            <div class="contentBox">
                <h2 class="word31 scroll-fade-up">常见问题</h2>
                <div class="QA-list">
                    <div class="QA-item">
                        <div class="QA-title word32">1、我如何向我的账户入金？</div>
                        <div class="QA-content">
                            <p class="QA-li word33">
                                在您建立账户后，可以通过我们的网络客户端进入您的支付首选项。<br />
                                具体操作：
                            </p>
                            <p class="QA-li num-li">系统将首先提示您选择要入金的帐户</p>
                            <p class="QA-li num-li">
                                然后使用付款方式表右侧的按钮选择付款方式。
                            </p>
                            <p class="QA-li num-li">输入您想向您的账户里入金的金额。</p>
                            <p class="QA-li num-li">
                                请仔细阅读所有说明，条款和条件，如果您同意，请确保选中“我已阅读所有说明并同意付款操作的条款和条件”。
                            </p>
                            <p class="QA-li num-li">【点击提交】</p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word34">2、为何我使用银联卡入金不成功？</div>
                        <div class="QA-content">
                            <p class="QA-li word35">
                                如果您的借记卡入金失败，请尝试再次入金，并检查：
                            </p>
                            <p class="QA-li num-li">您是否正确输入了您的卡片信息。</p>
                            <p class="QA-li num-li">您是否使用了有效（未过期）卡。</p>
                            <p class="QA-li num-li">您的卡中是否有足够的资金。</p>
                            <p class="QA-li">
                                如果不存在上述问题，但您仍然没有成功入金，那么可能是您的发卡行并未授权您的卡进行入金。如果是这样，请使用其他卡，或您的交易账户中的其他付款方式。
                            </p>
                        </div>
                    </div>

                    <div class="QA-item">
                        <div class="QA-title word36">3、我如何从我的账户中出金？</div>
                        <div class="QA-content">
                            <p class="QA-li word37">
                                您可以在任意时间提出出金申请。我们的账户部门每天都会处理请求。出金将转回到您的指定账户中。如果该选项不可用，资金将自动退回至客户的后台钱包中。另请注意，
                                银行电汇出金，请以各银行实际处理的时间为准。
                                各家银行到账时间不同，详细请咨询银行。
                                银联出金，如在晚上十点前，则一个工作日到账。
                                若在持仓时出金，请确保交易账户中的预付比例在扣除出金金额后依然高于200%，否则平台将无法处理您的取款申请。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title word38">4、EBC收取手续费吗？</div>
                        <div class="QA-content">
                            <p class="QA-li word39">
                                EBC对于采用任何支付方式的入金或出金，都不收取任何费用。但请注意，您向某些国际银行机构的付款或从这些机构办理的付款可能会产生费用。还请注意，您的银行可能会将支付给EBC的款项视为预付现金，并根据您的预付现金规则向您开具账单。
                            </p>
                        </div>
                    </div>

                    <div class="QA-item">
                        <div class="QA-title word40">
                            5、我是否可以用他人的银行卡入金/出金？
                        </div>
                        <div class="QA-content">
                            <p class="QA-li word41">
                                否，EBC不接受来自第三方的付款。请确保所有进入您交易账户的入金均来自您名下的账户。如交易账户的持有者是联合账户的其中一方，将会接受联合账户的付款。
                            </p>
                            <p class="QA-li">
                                如果我们怀疑是由第三方提供的资金，我们保留将资金退回给汇款人并冻结您账户余额的权利，等待验证身份证明和资金来源后再行处理。在未经验证的情况下，我们保留冻结您帐户余额的权利，您将不得提取您的帐户余额。
                            </p>
                            <p class="QA-li">
                                EBC不办理对第三方的出金。如有特殊情况，请联系我们。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <message-v3></message-v3>
        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from "vuex";
export default {
    mixins: [fadeAnimate],
    computed: {
        ...mapGetters(["signupUrl"]),
    },
    created() {

    },
    mounted() {
        this.initPage()
    },
    methods: {
        initPage() {
            const link = document.querySelector(
                'link[href*="/ebc-static/css/bootstrap.css"]'
            );
            if (link) {
                link.remove();
            }
            $(document).ready(function () {
                $(".accordion-item").click(function () {
                    if ($(this).children(".cont-info").is(":hidden")) {
                        $(this).children(".cont-info").css("display", "block");
                        $(".cont-info")
                            .not($(this).children(".cont-info"))
                            .css("display", "none");
                        $(".accordion-item").removeClass("rotate");
                        $(this).addClass("rotate");
                    } else {
                        $(this).children(".cont-info").css("display", "none");
                        $(this).removeClass("rotate");
                    }
                });
            });
         
            let rowSpanTd = document.querySelector(
                ".funding-way_table table tr:nth-child(1) td:last-child"
            );
            if (window.matchMedia("(max-width:996px)").matches) {
                rowSpanTd.setAttribute("rowspan", "1");
            }
            function syncFakeScroll(wrapperSel) {
                const wrap = document.querySelector(wrapperSel);
                const scroll = wrap.querySelector(".scrollTable");
                const innerTable = wrap.querySelector(".funding-way_table");
                const track = wrap.querySelector(".fake-scrollbar");
                const thumb = wrap.querySelector(".fake-thumb");

                function sync() {
                    const w = scroll.clientWidth;
                    const sw = scroll.scrollWidth;
                    const l = scroll.scrollLeft;
                    const maxL = sw - w;
                    if (maxL <= 0) {
                        thumb.style.width = "100%";
                        return;
                    }

                    const thumbW = (w / sw) * track.clientWidth;
                    thumb.style.width = thumbW + "px";
                    const maxMove = track.clientWidth - thumbW;
                    thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
                    if (l <= 0) {
                        wrap.classList.add("noScroll");
                    } else {
                        wrap.classList.remove("noScroll");
                    }
                }

                scroll.addEventListener("scroll", sync, { passive: true });
                const ro = new ResizeObserver((entries) => {
                    for (const e of entries) {
                        scroll.scrollLeft = 0;
                        thumb.style.transform = `translateX(0)`;
                        wrap.classList.add("noScroll");
                        setTimeout(() => {
                            sync();
                        });
                    }
                });
                ro.observe(innerTable);
                sync();
            }
            // 用法
            syncFakeScroll(".tableOverflowScrollContainer");
                (function () {
                    const tbl = document.querySelector('table');
                    if (!tbl) return;
                    const rows = [...tbl.tBodies[0].rows];

                    const mMap = new Map();
                    rows.forEach((tr, rIdx) => {
                        [...tr.cells].forEach(td => { if (td.rowSpan > 1) mMap.set(td, { startRow: rIdx, endRow: rIdx + td.rowSpan - 1, colIndex: td.cellIndex }); });
                    });

                    const rowBg = '#f7f7f7';
                    const mergeBg = '#f7f7f7';
                    const clear = '';

                    /* 关键修复：清色时把每个<td>都清掉 */
                    function clearAll() {
                        rows.forEach(tr => {
                            tr.style.backgroundColor = clear;
                            [...tr.cells].forEach(td => td.style.backgroundColor = clear);
                        });
                    }

                    function lightRowAndMerge(rIdx) {
                        const tr = rows[rIdx];
                        [...tr.cells].forEach(td => { if (!mMap.has(td)) td.style.backgroundColor = rowBg; });
                        mMap.forEach((info, mergeTd) => { if (rIdx >= info.startRow && rIdx <= info.endRow) mergeTd.style.backgroundColor = mergeBg; });
                    }

                    function lightBlock(info) {
                        for (let i = info.startRow; i <= info.endRow; i++) {
                            [...rows[i].cells].forEach(td => { if (!mMap.has(td)) td.style.backgroundColor = rowBg; });
                            rows[info.startRow].cells[info.colIndex].style.backgroundColor = mergeBg;
                        }
                    }

                    mMap.forEach((info, mergeTd) => {
                        mergeTd.addEventListener('mouseenter', () => lightBlock(info));
                        mergeTd.addEventListener('mouseleave', clearAll);
                    });

                    rows.forEach((tr, rIdx) => {
                        [...tr.cells].forEach(td => {
                            if (!mMap.has(td)) {
                                td.addEventListener('mouseenter', () => lightRowAndMerge(rIdx));
                                td.addEventListener('mouseleave', clearAll);
                            }
                        });
                    });
                })();

        }
    }
}
</script>
<style lang="scss">
@import url("../assets/css/commonQuestion.scss");

.container4 .QA-list .QA-item .QA-title span {
    font-size: 30rem;
}

.container4 .QA-list .QA-item .QA-title span:first-child {
    display: inline;
}

.container4 .QA-list .QA-item .QA-title span:nth-child(2) {
    display: none;
}

.container4 .QA-list .QA-item.showList .QA-title span:first-child {
    display: none;
}

.container4 .QA-list .QA-item.showList .QA-title span:nth-child(2) {
    display: inline;
}
</style>
<style scoped>
.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

.funding_header {
  background: #f2f2f2;
  padding-top: 116rem;
  min-height: 560rem;
  gap: 0rem;
  padding-left: calc(50vw - 600rem);
}
.funding_main {
  padding-top: 44rem;
  flex: 0 0 588rem;
  position: relative;
  z-index:2;
}

.funding_title {}

.funding_desc {
    color: var(--ebc-text-secondary);
    margin: 24rem 0 64rem;
}

.fundingJPTable {
    max-width: 100%;
}

@media screen and (min-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .ar .funding_header {
        padding-left: unset;
        padding-right: calc(50vw - 600rem);

    }

    .ru .funding_desc,
    .ar .funding_desc,
    .es .funding_desc,
    .id .funding_desc,
    .pt .funding_desc,
    .en .funding_desc,
    .ug .funding_desc {
        margin-bottom: 32rem;
    }

    .id .funding_header,
    .ru .funding_header {
        gap: 167rem;
    }

    .id .funding_main,
    .ru .funding_main {
        flex: 0 0 668rem;
    }

    .es .funding_header {
        gap: 77rem;
    }

    .es .funding_main {
        flex: 0 0 758rem;

    }
}

.funding_btn {
    width: fit-content;
    min-width: 180rem;
}

.funding_model {
  height: 444rem;
  margin-left: -100rem;
}

.icon-right {
    display: inline-block;
    margin-left: 5rem;
}

@media screen and (max-width: 996px) {
    .ar .funding_model {
        margin-right: 100rem;
    }

    .fundingJPTable {
        order: 2;
    }

    .contentBox {
        padding-inline: 32rem;
        max-width: 100%;
    }

    #page-navigate {
        background: #fff !important;
    }

    section {
        padding-inline: 32rem !important;
    }

    .funding_header {
        flex-direction: column;
        gap: 0;
        align-items: center;
        padding-bottom: 80rem;
        padding-top: 0;
        overflow: hidden;
    }

    .funding_main {
        order: 2;
        text-align: center;
        padding-top: 30rem;
        flex-basis: unset;
        width: 100%;
    }

    .funding_model {
    height: 542rem;
    margin-left: -190rem;
    margin-top: 80rem;
    margin-bottom: -20rem;
    max-width: unset;
  }

    .funding_desc {
        margin: 16rem 0 64rem;
    }

    .funding_btn {
        width: 100%;
        gap: 8rem;
    }
}

.funding-advantage {
    padding-bottom: 40rem;
    background: #fff;
}

.funding-advantage_cardList {
    padding: 32rem;
    border-radius: var(--ebc-corner-radius-rc16);
    border: 1px solid #fff;
    background: linear-gradient(250deg,
            rgba(255, 255, 255, 0.8) 36.88%,
            #fff 100%);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    transform: translateY(-70rem);
}

.funding-advantage_card {
    flex: 1;
    text-align: center;
}

.funding-advantage_card svg {
    width: 64rem;
}

.funding-advantage_cardTip {
    margin: 16rem 0 8rem;
}

.funding-advantage_cardDesc {
    color: var(--ebc-text-secondary);
}

.funding-advantage_cardSplitLine {
    width: 1px;
    height: 64rem;
    background: rgba(0, 0, 0, 0.08);
    margin-inline: 32rem;
}

@media screen and (max-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .funding-advantage {
        padding: 80rem 32rem 160rem;
    }

    .funding-advantage h2 {
        text-align: center;
    }

    .funding-advantage .funding-advantage_cardList {
        flex-wrap: wrap;
        gap: 32rem;
        background: none;
        box-shadow: none;
        padding: 0;
        margin-top: 80rem;
        transform: translateY(0);
        backdrop-filter: unset;
        align-items: stretch !important;
    }

    .funding-advantage_card {
        flex: 0 0 325rem;
        padding: 32rem;
        text-align: left;
        border-radius: var(--ebc-corner-radius-rc16);
        background: var(--ebc-neutral-bg_b);
    }

    .funding-advantage_card:nth-child(5) {
        flex: 1;
    }

    .funding-advantage_card svg {
        width: 64rem;
        height: 64rem;
    }

    .funding-advantage_cardTip {
        margin: 32rem 0 16rem;
    }
}

.funding-solution {
    background: #fff;
    padding-bottom: 120rem;
}

.funding-solution_desc {
    color: var(--ebc-text-secondary);
    margin: 16rem auto 60rem;
}

.funding-solution_logoList {
    padding-inline: calc(50vw - 610rem);
    margin-inline: auto;
    position: relative;
}

.funding-solution_logoListRowLine {
    position: absolute;
    height: 1px;
    width: 100%;
    background: linear-gradient(90deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.2) 40%,
            rgba(0, 0, 0, 0.2) 60%,
            rgba(0, 0, 0, 0) 100%);
    opacity: 0.3
}

.funding-solution_logoItem .funding-solution_logoItemCorner {
    width: 7rem !important;
    height: 7rem;
    opacity: .5;

}

.solution_logoItemAddTopLeft {
    position: absolute;
    left: 4rem;
    top: -3rem;
}

.solution_logoItemAddTopRight {
    position: absolute;
    right: -11rem;
    top: -3rem;
}

.solution_logoItemAddBottomLeft {
    position: absolute;
    left: 4rem;
    bottom: -5rem;
}

.solution_logoItemAddBottomRight {
    position: absolute;
    right: -11rem;
    bottom: -5rem;
}

.funding-solution_logoListRowLine:nth-child(9) {
    top: 0;
}

.funding-solution_logoListRowLine:nth-child(10) {
    top: 233rem;
}

.funding-solution_logoListRowLine:nth-child(11) {
    top: 466rem;
}

@media screen and (min-width: 996px) {

    .funding-solution_logoListRowLine:nth-child(18),
    .funding-solution_logoListRowLine:nth-child(17) {
        display: none;
    }

}

.funding-solution_logoListColumnLine {
    position: absolute;
    width: 1px;
    height: 690rem;
    opacity: 0.3;
    background: linear-gradient(180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.2) 40%,
            rgba(0, 0, 0, 0.2) 60%,
            rgba(0, 0, 0, 0) 100%);
    top: -120rem;
    left: 0;
}

.funding-solution_logoListColumnLine:nth-child(12) {
    left: calc(50vw - 600rem);
}

.funding-solution_logoListColumnLine:nth-child(13) {
    left: calc(50vw - 300rem);
}

.funding-solution_logoListColumnLine:nth-child(14) {
    left: 50vw;
}

.funding-solution_logoListColumnLine:nth-child(15) {
    left: calc(50vw + 300rem);
}

.funding-solution_logoListColumnLine:nth-child(16) {
    left: calc(50vw + 600rem);
}

.funding-solution_logoItem {
    flex: 0 0 300rem;
    height: 233rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.funding-solution_logoItem:nth-child(1) img {
    width: 180rem;
}

.funding-solution_logoItem:nth-child(2) img {
    width: 220rem;
}

.funding-solution_logoItem:nth-child(3) img {
    width: 101rem;
}

.funding-solution_logoItem:nth-child(4) img {
    width: 150rem;
}

.funding-solution_logoItem:nth-child(5) img {
    width: 140rem;
}

.funding-solution_logoItem:nth-child(6) img {
    width: 199rem;
}

.funding-solution_logoItem:nth-child(7) img {
    width: 182rem;
}

.funding-solution_logoItem:nth-child(8) img {
    width: 181rem;
}

/* .grayscale {
  filter: grayscale(1);
  -webkit-filter: grayscale(1);
  cursor: pointer;
}
.grayscale:hover {
  filter: none;
} */

@media screen and (max-width: 996px) {
    .solution_logoItemAddBottomLeft {
        left: -6rem;
        bottom: -4rem;
    }

    .funding-solution {
        padding: 0 0 160rem !important;
    }

    .funding-solution_desc {
        margin: 16rem auto 80rem;
    }

    .funding-solution_logoListRowLine:nth-child(17) {
        top: 700rem;
    }

    .funding-solution_logoListRowLine:nth-child(18) {
        top: 932rem;
    }

    .funding-solution_logoListColumnLine:nth-child(12) {
        left: 75rem;
    }

    .funding-solution_logoListColumnLine:nth-child(13) {
        left: 375rem;
    }

    .funding-solution_logoListColumnLine:nth-child(14) {
        left: 675rem;
    }

    .funding-solution_logoListColumnLine {
        height: 1080rem;
        top: -60rem;
    }

    .funding-solution_logoListColumnLine:nth-child(15),
    .funding-solution_logoListColumnLine:nth-child(16) {
        display: none;
    }

    .funding-solution_logoItem .funding-solution_logoItemCorner {
        width: 12rem !important;
        height: 12rem;
    }

    .solution_logoItemAddTopLeft {
        left: -4rem;
        top: -7rem;
    }

    .solution_logoItemAddTopRight {
        right: -7rem;
        top: -7rem;
    }

    .solution_logoItemAddBottomRight {
        right: -7rem;
        bottom: -7rem;
    }

    .grayscale {
        filter: none;
    }
}

.funding-protect {
    background: var(--ebc-neutral-bg_b);
    padding: 120rem 0;
}

.funding-protect_desc {
    color: var(--ebc-text-secondary);
    margin: 16rem 0 60rem;
}

.funding-protect .funding-protect_cardList {
    gap: 24rem;
    align-items: stretch;
}

.funding-protect_card {
    background: var(--ebc-neutral-bg_a);
    border-radius: var(--ebc-corner-radius-rc16);
    padding: 40rem 32rem 34rem;
}

.funding-protect_cardDesc {
    margin: 16rem 0;
    color: var(--ebc-text-secondary);
}

.funding-protect_cardLogoList {
    height: 104rem;
    margin-top: auto;
    gap: 50rem;
}

.funding-protect_card {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.funding-protect_cardLogo1 {
    width: 272rem;
}

.funding-protect_cardLogo2 {
    width: 125rem;
}

.funding-protect_cardLogo3 {
    width: 90rem;
    order:2;
}

.funding-protect_cardLogo4 {
    width: 155rem;
}

.funding-protect_cardBtn {
    width: fit-content;
    display: inline-block;
}

.funding-protect_cardBtn div {
    border: 0 !important;
    padding-inline: 0;
}

@media screen and (max-width: 996px) {
    .funding-protect {
        padding: 160rem 0;
    }

    .funding-protect_desc {
        margin: 16rem 0 80rem;
    }

    .funding-protect .contentBox {
        padding-inline: 0;
    }

    .funding-protect_cardList {
        gap: 32rem;
        flex-direction: column;
    }

    .funding-protect_card {
        position: relative;
        padding: 48rem 32rem;
        min-height: 480rem;
    }

    .funding-protect_cardDesc {
        margin: 32rem 0 60rem;
    }

    .zh .funding-protect_cardBtn {
        position: absolute;
        right: 32rem;
        top: 30rem;
    }

    .funding-protect_cardBtn {
        position: static;
        margin-bottom: 30rem;
        margin-top: -20rem;
    }

    .funding-protect_cardLogoList {
        gap: 40rem;
    }

    .funding-protect_cardLogo1 {
        width: 402rem;
    }

    .funding-protect_cardLogo2 {
        width: 156rem;
    }

    .funding-protect_cardLogo3 {
        width: 106rem;
    }

    .funding-protect_cardLogo4 {
        width: 206rem;
    }
}

.funding-way {
    padding: 120rem 0;
    background: var(--ebc-neutral-bg_a);
}

.funding-way_btn {
    min-width: 180rem;
    width: fit-content;
}

.funding-way_desc {
    color: var(--ebc-text-secondary);
    margin: 16rem 0 60rem;
}

.funding-way_container {
    flex-direction: column;
}

.funding-way_table {
    border-radius: var(--ebc-corner-radius-rc16);
    border: 1px solid rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

.funding-way_table table {
    width: 1200rem;
}

.funding-way_table table .thead {
    background: var(--ebc-neutral-bg_c);
}

.funding-way_table table td,
.funding-way_table table .thead th {
    padding: 24rem 0;
    min-height: 72rem;
}

.funding-way_table table .thead th {
    font-weight: 500;
}

.funding-way_table table td,
.funding-way_table table th {
    text-align: center;
    vertical-align: middle;
}

.funding-way_table table th,
.funding-way_table table td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    border-right: 1px solid rgba(0, 0, 0, 0.12)
}

.funding-way_table table tr:nth-child(1) td:last-child,
.funding-way_table table tr:last-child td {
    border-bottom: 0;
}

.funding-way_table table tr td:nth-child(3),
.funding-way_table table tr:nth-child(1) td:last-child {
    font-size: 16rem;
    font-weight: 500;
}

.funding-way_table table tr td:nth-child(3) {
    color: var(--ebc-basecolor-active-500);
}

.funding-way_table table .innerTd {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8rem;
    padding-left: 35rem;
    text-align: left;
}

.zh .funding-way_table table .innerTd {
    justify-content: center
}

.zh .funding-way_table table th:nth-child(1) {
    text-align: center;
    padding-inline: 10rem;
}

.funding-way_table table .innerTd svg {
    width: 24px;
    height: 24px;
}

.funding-way_table table td:nth-child(1),
.funding-way_table table th:nth-child(1) {
    width: 160rem;
}

.funding-way_table table td:nth-child(2),
.funding-way_table table th:nth-child(2) {
    width: 400rem;
}

.funding-way_table table td:nth-child(3),
.funding-way_table table th:nth-child(3) {
    width: 212rem;
}

.funding-way_table table td:nth-child(4),
.funding-way_table table th:nth-child(4) {
    width: 212rem;
}

.funding-way_table table td:nth-child(5),
.funding-way_table table th:nth-child(5) {
    width: 210rem;
}

@media (min-width:996px) {

    .vi .funding-way_table table td:nth-child(1),
    .vi .funding-way_table table th:nth-child(1) {
        width: 260rem;
    }

    .vi .funding-way_table table td:nth-child(2),
    .vi .funding-way_table table th:nth-child(2) {
        width: 300rem;
    }

    .kr .funding-way_table table td:nth-child(1),
    .kr .funding-way_table table th:nth-child(1) {
        width: 200rem;
    }

    .kr .funding-way_table table td:nth-child(2),
    .kr .funding-way_table table th:nth-child(2) {
        width: 360rem;
    }

    .funding-way_table table th:nth-child(1) {
        text-align: left;
        padding-left: 35rem;
    }

    .th .funding-way_table table td:nth-child(2),
    .th .funding-way_table table th:nth-child(2),
    .enTable .funding-way_table table td:nth-child(2),
    .enTable .funding-way_table table th:nth-child(2) {
        width: 280rem;
    }

    .th .funding-way_table table td:nth-child(1),
    .th .funding-way_table table th:nth-child(1),
    .enTable .funding-way_table table td:nth-child(1),
    .enTable .funding-way_table table th:nth-child(1) {
        width: 270rem;
    }

    .th .funding-way_table table td:nth-child(5),
    .th .funding-way_table table th:nth-child(5),
    .enTable .funding-way_table table td:nth-child(5),
    .enTable .funding-way_table table th:nth-child(5) {
        width: 230rem;
    }

    .th .funding-way_table table tr:nth-child(1) td:last-child {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }

    .th .funding-way_table table tr:nth-child(2) td:last-child {
        border: 0;
    }

    .ar .funding-way_table table th:nth-child(1) {
        text-align: right;
        padding-right: 35rem;
    }

    .funding-way_table table .innerTd {
        padding-right: 35rem;
    }
}

.funding-way_tableFooter {
    color: var(--ebc-text-tertiary);
    margin: 24rem 0 60rem;
    padding-left: 35rem;
    text-align: left;
    width: 100%;
}

@media (max-width: 996px) {

    .funding-way {
        padding: 160rem 0;
    }

    .funding-way .contentBox {
        padding-inline: 32rem;
        margin-inline: 0;
    }

    .funding-way_desc {
        margin: 16rem 0 80rem;
    }

    .funding-way_btn {
        min-width: 240rem;
    }

    .funding-way_btn div {
        font-size: 28rem;
        height: 80rem;
        line-height: 0rem;
    }

    .tableOverflowScrollContainer {
        position: relative
    }

    .tableOverflowScrollContainer,
    .funding-way_tableFooter {
        order: 2;
    }

    .funding-way_btn {
        margin-bottom: 80rem;
    }

    .funding-way_tableFooter {
        margin: 48rem 0 0;
    }

    .corner-mask {
        position: absolute;
        left: 0rem;
        top: -2%;
        width: 40px;
        height: 104%;
        background: #fff;
        z-index: 2;
        pointer-events: none;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    .funding-way_table table {
        width: fit-content;
    }

    table thead {
        flex: 0 0 240rem;
        border: 0;
        position: sticky;
        left: 32rem;
        z-index: 3;
        background: none;
    }

    table,
    table tbody {
        display: flex;
    }

    .funding-way_table {
        overflow: unset;
        border: 0;
    }

    .funding-way_table table th {
        font-weight: 500;
    }

    .funding-way_table table .thead th,
    .funding-way_table table tbody td {
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        box-sizing: border-box;
        height: 140rem;
    }

    .funding-way_table table tbody td {
        justify-content: center;
        ;
    }

    .funding-way_table table .innerTd {
        gap: 16rem;
        padding-left: 0;
        white-space: nowrap;
    }

    .funding-way_table table tr td:nth-child(3) {
        font-size: 32rem;
        font-weight: 500;
    }

    .funding-way_table table th {
        width: fit-content !important;
        min-width: 240rem;
        justify-content: center;
    }

    .funding-way_table table td {
        width: 100% !important;
        min-width: 400rem;
        text-align: center;

    }

    .vi .funding-way_table table th {
        min-width: 300rem;
    }

    table tr {
        display: flex;
        flex-direction: column;
    }

    table,
    tbody {
        width: fit-content;
    }

    .scrollTable {
        overflow: auto;
        max-width: 95vw;
    }

    .scrollTable::-webkit-scrollbar {
        display: none;
    }

    .funding-way_table {
        width: fit-content;
        max-width: unset !important;
        overflow: auto;
        margin: 0;
        overflow-x: auto;
        border: 0;
        border-radius: 32rem;
        /* position:relative; */
        overflow: visible;
        /* margin-right: 32rem!important; */
    }

    .funding-way_table table tr:nth-child(1) td:last-child {
        font-size: 28rem;
        font-weight: 400;
    }

    .funding-way_table table td {
        justify-content: center;
        padding-inline: 32rem;
    }

    .funding-way_table table th {
        padding-inline: 32rem !important;
    }

    .enTable .funding-way_table table th {
        padding-inline: 24rem !important;
        line-height: 36rem;
    }

    .enTable .funding-way_table table .thead th,
    .enTable .funding-way_table table tbody td {
        height: 170rem;
    }

    .funding-way_table table th:first-child,
    .funding-way_table table td:first-child {
        border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
    }

    .funding-way_table table th {
        border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
    }

    .funding-way_table table th,
    .funding-way_table table td {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
        border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
    }

    .funding-way_table table th:first-child {
        border-top-left-radius: 32rem;
    }

    .funding-way_table table th:last-child {
        border-bottom-left-radius: 32rem;
    }

    .funding-way_table table tr:last-child td:first-child {
        border-top-right-radius: 32rem;
    }

    .funding-way_table table tr:last-child td:last-child {
        border-bottom-right-radius: 32rem;
    }

    .funding-way_table table .thead {
        background: transparent;
    }

    .funding-way_table table .thead th {
        background: var(--ebc-neutral-bg_c);
    }

    table::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 90%;
        height: 1px;
        background-color: rgba(0, 0, 0, .12);
        transform: scaleY(0.5);
        /* 根据设备像素比调整，可以是0.5, 0.33等 */
    }

    table th::after {
        content: '';
        position: absolute;
        top: 0;
        right: -8px;
        width: 8px;
        height: 100%;
        background: linear-gradient(to right, rgba(0, 0, 0, 0.04), transparent);
        pointer-events: none;
    }

    .noScroll table th::after {
        display: none;
    }

    /* 伪滚动条容器 */
    .fake-scrollbar {
        position: absolute;
        left: 32rem;
        right: 32rem;
        bottom: -40rem;
        height: 4px;
        background: rgba(0, 0, 0, .1);
        border-radius: 2px;
        pointer-events: none;
        /* 只看不点 */
    }

    /* 伪滑块 */
    .fake-thumb {
        height: 100%;
        background: rgba(0, 0, 0, .4);
        border-radius: 2px;
        width: 0;
        /* js 动态算 */
        transition: width .2s;
    }

    .funding-way_tableFooter {
        margin-top: 90rem;
    }

    .ar .funding-way_table table tr th {
        border-left: 0 !important
    }

    .ar .funding-way_table table tr th:first-child {
        border-top-left-radius: 0;
        border-top-right-radius: 32rem;
    }

    .ar .funding-way_table table tr th:last-child {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 32rem;
    }

    .ar .funding-way_table table tr:last-child td:first-child {
        border-top-right-radius: 0;
        border-top-left-radius: 32rem;
        border-top: 1px solid rgba(0, 0, 0, 0.12)
    }

    .ar .funding-way_table table tr:last-child td:last-child {
        border-bottom-right-radius: 0rem;
        border-bottom-left-radius: 32rem;
    }

    .ar .funding-way_table table tr:last-child td {
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-top: 0;
    }

    .ar table thead {
        position: absolute;
        right: 32rem;
        left: unset;
        width: 240rem;
    }

    .ar table {
        padding-right: 240rem;
    }

    .ar .funding-way_table {
        margin-right: unset !important;
        margin-left: 32rem !important;
    }

    .ar .corner-mask {
        left: unset;
        right: 0;
        width: 45px;
    }

    .ar table th::after {
        right: unset;
        left: -3px;
        background: linear-gradient(to left, rgba(0, 0, 0, 0.04), transparent);
    }
}



</style>
